import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import dealerAddUserPermissionDefinition from "./dealer-add-user-permission";

const useDealerAddUserPermissions = () => {
  return useUserPermissions(dealerAddUserPermissionDefinition);
};

export default useDealerAddUserPermissions;
